'use client';

import { useEffect } from 'react';

import { useBlogTracking } from '@/modules/blog/hooks/useBlogTracking';

export function ArticleTracking() {
  const { sendBlogArticleViewEvent } = useBlogTracking();

  useEffect(() => {
    sendBlogArticleViewEvent();
  }, []);

  return null;
}
